module.exports = __webpack_public_path__ + "img/rectangle.acb83db3.svg";